import httpClient from '@/http-client'

export const get = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/sub-task-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/sub-task-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .post(`/api/v1/sub-task-profiles/${id}/update`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/sub-task-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const report = (id, data) => {
  return httpClient
    .post(`/api/v1/sub-task-profiles/${id}/material-report`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getReport = id => {
  return httpClient
    .get(`/api/v1/sub-task-profiles/${id}/reports`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const subTaskByProject = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/sub-task-profiles/${id}/projects`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const importSub = data => {
  return httpClient
    .post(`/api/v1/sub-task-profiles/import`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const downloadTemplate = data => {
  return httpClient
    .post('/api/v1/sub-task-profiles/download-template', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  destroy,
  update,
  report,
  getReport,
  subTaskByProject,
  importSub,
  downloadTemplate
}
